<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header">
    <div class="modal-title">Stream Preview: </div>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <iframe style="border: none" width="100%" height="500" [src]="dialog.initialState.playBackUrl | safe" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
  </div>
</ng-container>
